import { call, put, takeLatest } from "redux-saga/effects";
import get from "lodash/get";
import { httpRequest } from "../../../utils/networkCalls";
import { updateLoadingStatus } from "../../Loader/LoaderReducer";
import {showToastMessage} from "../../../utils/common"
import {  AIMHLP_FETCH_SUB_DETALIS, aiMhUpdateSubDetails } from "../AimhLandingPage/AimhLpReducer";

// Generate description
export function* aimhFectchSubDetails(action) {
    try {
        // Show Loader here
        yield put(updateLoadingStatus(true));

        // Call API
        const res = yield call(
            httpRequest,
            `ai-marketing-hub/is-user-subscribed`,
            "post",
            {email:action.payload.userDetails?.email},
        );

        if (res?.status === "success") {
            // Set Response in Reducer
            yield put(aiMhUpdateSubDetails({ details: res?.data }));
        }else if(res?.status==="error" && res?.data){
            showToastMessage({ icon: "error", mssge: res?.data, time: 3000 });
        }else if(res?.status==="error"){
            showToastMessage({ icon: "error", mssge: "Something went wrong", time: 3000 });
        }

        // Hide Loader here
        yield put(updateLoadingStatus(false));

    } catch (err) {
        throw err;
    }
}

export function* sagaAimhLandingPage(params) {
    // GenEmailDesc gets called when AI_DESC_PD_GENERATE_DESC is dispatched
    yield takeLatest(AIMHLP_FETCH_SUB_DETALIS, aimhFectchSubDetails);
}
